import { useRef, useLayoutEffect } from 'react';

/**
 * @example const previousValue = usePrevious(value);
 * @param value The value to store before a re-render.
 * @returns previousValue:: The value that was stored prior to a re-render.
 */
const usePrevious = <T>(value: T) => {
  const ref = useRef<T>();
  useLayoutEffect(() => {
    ref.current = value;
  }, [value]);

  return ref.current;
};

export default usePrevious;
